import Base from './Base';
import Inbox from '../models/Inbox';

export default class Inboxes extends Base {
    get models() {
        const collection = this.data.map(item => new Inbox(item));
        collection.collection = this;

        return collection;
    }
}
